import { useContext, useEffect } from "react";
import { Context_UI } from "../../Contexts/Context_UI";
export default function UI_Form({ id, Submit, Composition, children, Compress }) {
    const UI = useContext(Context_UI);
    return (
        <form class="Input_Form" onSubmit={Submit} id={id} Composition={Composition} Compress={Compress? "Compress":undefined}>
            {children}
        </form>
    )
}

